module.exports = __webpack_public_path__ + "img/q11.1fbcae09.png";